import {
  CircularProgress,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../constants";

const UserList = ({ fetchUsers, setSelectedUser, selectedUser }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAllUsers = async () => {
      setLoading(true);
      const orgId = localStorage.getItem("orgId");
      try {
        const response = await fetch(
          `${BASE_URL}api/org/get-all-users/${orgId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const users = await response.json();
        setUsers(users.data);
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong! Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchAllUsers();
  }, [fetchUsers]);

  const selectUserHandler = (user) => {
    setSelectedUser(user);
  };
  console.log("SElected", selectedUser);
  return (
    <List sx={{ padding: 1, width: "100%", maxWidth: 480, margin: "0 auto" }}>
      {!loading &&
        users?.map((user, index) => (
          <Tooltip
            key={index}
            title={`${user.userName} : ${user.userEmail}`}
            arrow
            placement="right"
          >
            <ListItem
              sx={{
                display: "flex",
                alignItems: "center",
                transition: "transform 0.2s, box-shadow 0.3s",
                cursor: "pointer",
                borderRadius: 2,
                "&:hover": {
                  transform: "scale(1.03)",
                },
                backgroundColor: `${
                  selectedUser?._id === user?._id
                    ? "rgba(245, 247, 250, 0.8)"
                    : "#fff"
                }`,
                border: "1px solid #e0e0e0",
                overflow: "hidden",
                marginBottom: 1.5,
              }}
            >
              <ListItemText
                primary={
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    sx={{ letterSpacing: 0.5 }}
                  >
                    {user.userName}
                  </Typography>
                }
                secondary={
                  <Typography variant="body2" color="text.secondary">
                    {user.userEmail}
                  </Typography>
                }
                sx={{ overflow: "hidden" }}
                onClick={() => selectUserHandler(user)}
              />
            </ListItem>
          </Tooltip>
        ))}
      {loading && (
        <DialogActions sx={{ justifyContent: "center", paddingY: 4 }}>
          <CircularProgress size={36} thickness={4} />
        </DialogActions>
      )}
      {!loading && users?.length === 0 && (
        <Typography
          variant="body1"
          color="white"
          sx={{
            textAlign: "center",
            marginTop: 2,
            fontWeight: "medium",
          }}
        >
          You have no users
        </Typography>
      )}
    </List>
  );
};

export default UserList;
